import { Component, OnInit } from '@angular/core';
import { ABCisTableModel, ColumnType } from 'src/app/components/abcis-table/abcis-table.component';
import { ABCisApi } from 'src/app/handlers/apiHandler.service';

@Component({
  selector: 'app-global-store-purchase-plu-config',
  standalone: false,
  templateUrl: './global-store-purchase-plu-config.component.html',
  styleUrls: ['./global-store-purchase-plu-config.component.scss']
})
export class GlobalStorePurchasePluConfigComponent implements OnInit {
  tableConfig: ABCisTableModel;
  constructor() { }

  /**
   * Primary key : storeId, plu
  */
  ngOnInit(): void {
    this.tableConfig = {
      apiConfig: {
        api: ABCisApi.Support,
        table: 'null',
        url: 'global-store-purchase-plu',
        approxamateRowCount: 1000,
        anyParams: true

      },
      colConfig: [
        { field: 'storeId', header: 'Store ID', type: ColumnType.MultiSelectComplex, setUrl: 'store/lookup' ,isSingleSelect: true, isReadonly: true, isPrimary: true  },
        { field: 'plu', header: 'PLU', type: ColumnType.String, isReadonly: true, isPrimary: true },
      ],
      addFormConfig: {
        header: 'Add Global Store Purchase PLU'
      },
      isConfigurable: true,
      canEdit: false
    };
  }

}
